<template>
  <BBtn
    flat
    fit
    position="center"
    size="small"
    @click="handleDelete"
  >
    {{ $t('general.delete.do') }}
  </BBtn>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { ZoomPhoneResult } from '@/api/openapi';
import { ZoomPhoneResultApiService } from '@/api/user/resources/zoom_phone_result';
import { useConfirm } from '@/composable/message-dialog';
import { useWait } from '@/composable/vue-wait';
import { KEY_OF_TOAST } from '@/injection-keys';

type TProps = {
  zoomPhoneResult: ZoomPhoneResult | null;
};

const props = defineProps<TProps>();
const { confirm } = useConfirm();
const i18n = useI18n();
const api = new ZoomPhoneResultApiService();

const { doActionWithWait } = useWait();
const toast = inject(KEY_OF_TOAST);

const route = useRoute();
const router = useRouter();
const callListLink = computed(() => ({ name: 'VaCallList', query: route.query }));


const handleDelete = async () => {
  if (!props.zoomPhoneResult) return;
  const result = await confirm({
    title: i18n.t('general.confirm.text'),
    message: i18n.t('vaApp.zoomPhoneResult.delete.confirmDialog.message'),
  });
  if (!result) return;

  await doActionWithWait('deleteZoomPhoneResultWait', async () => {
    await api.deleteZoomPhoneResult({ request: { id: props.zoomPhoneResult.id } });
  });
  toast.show({
    message: i18n.t('general.done.of', { action: i18n.t('general.delete.text') }),
    type: 'success',
  });
  await router.push(callListLink.value);
};
</script>
